export const PREFERRED_LANGUAGE_CODE = 'preferredLanguageCode';
